import { Calculator, BadgePercent, Scale, NotebookPen, ShoppingCart, FileDown } from "lucide-react";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./Section";

const FEATURES = [
  {
    icon: Calculator,
    title: "Hitung HPP",
    text: "Bantu menghitung biaya pokok produk berdasarkan data dan biaya yang kamu masukkan.",
  },
  {
    icon: BadgePercent,
    title: "Tentukan Harga Jual",
    text: "Gunakan hasil perhitungan biaya, margin, dan harga jual sebagai bahan pertimbangan sebelum menentukan harga produk.",
  },
  {
    icon: Scale,
    title: "Hitung BEP (Break-Even Point)",
    text: "Perkirakan jumlah penjualan dan omzet yang diperlukan untuk mencapai titik impas berdasarkan biaya dan harga yang dimasukkan.",
  },
  {
    icon: NotebookPen,
    title: "Kelola Bahan dan Resep",
    text: "Catat bahan serta resep produk yang diperlukan untuk mendukung perhitungan biaya produk, sesuai fitur yang tersedia.",
  },
  {
    icon: ShoppingCart,
    title: "Kasir Sederhana dan Pencatatan Penjualan",
    text: "Catat transaksi penjualan agar aktivitas usaha lebih mudah ditinjau kembali.",
  },
  {
    icon: FileDown,
    title: "Laporan dan Ekspor PDF",
    text: "Lihat ringkasan data yang tersedia dan ekspor laporan dalam PDF jika diperlukan.",
  },
];

export function Features() {
  return (
    <section id="fitur" className="scroll-mt-20 bg-slate-50 py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <SectionHeading title="Yang Kamu Butuhkan untuk Memahami Angka Usaha" />
        </Reveal>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={(i % 3) * 0.08}>
              <article
                data-testid={`feature-card-${i + 1}`}
                className="h-full rounded-2xl border border-slate-200 bg-white p-6 transition-[box-shadow,border-color] duration-200 hover:border-teal-200 hover:shadow-md"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-teal-600 text-white">
                  <f.icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-lg font-semibold text-slate-900">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{f.text}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
